import { LegalContact } from "@omni/types/api/product/bff/shared/legalContact.model";
import { cn } from "@omni/utils/styles";
import { Fragment } from "react/jsx-runtime";

import { Divider } from "@/components/General/Divider/divider.component";

import { LegalContactComponent } from "./legalContact.component";

type LegalContactsProps = {
    contacts?: Array<LegalContact>;
};

const LegalContacts = ({ contacts = [] }: LegalContactsProps) => {
    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-3 tw:p-3")}>
            {contacts.map((contact, index) => (
                <Fragment key={index}>
                    <LegalContactComponent
                        key={`legal-contact-${index}-${contact.type}`}
                        contact={contact}
                    />
                    <Divider marginTop="0" />
                </Fragment>
            ))}
        </div>
    );
};

export { LegalContacts };
